import { gql, useMutation } from '@apollo/client';
import type { Popup, PopupVariant } from '@shady-pines/db';
import type { Timestamp, Url } from '@shady-pines/types';
import { useCallback } from 'react';
import type { MutationResponse } from '../types';

const UPDATE_POPUP_MUTATION = gql`
  mutation UpdatePopup($id: UUID!, $set: popupsUpdateInput!) {
    updatepopupsCollection(filter: { id: { eq: $id } }, set: $set) {
      records {
        __typename
        id
        title
        description
        expires_at
        active_at
        enabled
        variant
        external_url
      }
    }
  }
`;

type UpdatePopupInput = {
  title?: string;
  description?: string;
  expires_at?: Timestamp;
  active_at?: Timestamp;
  enabled?: boolean;
  variant?: PopupVariant;
  external_url?: Url | null;
};

export const useUpdatePopup = () => {
  const [updatePopupMutation, { loading, error }] =
    useMutation<MutationResponse<'updatepopupsCollection', Popup>>(UPDATE_POPUP_MUTATION);

  const update = useCallback(
    async (id: string, input: UpdatePopupInput) => {
      return updatePopupMutation({
        variables: {
          id,
          set: input,
        },
      });
    },
    [updatePopupMutation],
  );

  return {
    updatePopup: update,
    loading,
    error,
  };
};
